/**
 * 檢查或取代斜線
 * @typedef {Object} filterSlash
 * @property {string} text - 檢查的字串
 * @property {boolean} isReplace - 是否要取代
 * @property {string} replaceText - 取代後的問字
 * @returns {boolean|string} 若只有檢查返回布林值 ( 有斜線返回 true )，若有取代返回字串
 */
export const filterSlash = (text = '', isReplace = false, replaceText = '') => {
    if (typeof text !== 'string') return false;
    const reg = /[/\\]+/g;

    if (isReplace) return text.replace(reg, replaceText);
    else {
        if (reg.test(text)) return true;
        else return false;
    }
};

/**
 * Filter out the keys with values that are undefined or null from the input object
 * @typedef {Object} filterUndefinedOrNull
 * @property {string} obj - 要過濾的的物件
 */
export const filterUndefinedOrNull = obj => {
    if (!obj || typeof obj !== 'object') return {};
    if (Object.keys(obj).length === 0) return obj;

    for (const key in obj) {
        if (obj[key] === undefined || obj[key] === null) {
            delete obj[key];
        }
    }
    return obj;
};

/**
 * To extract the UUID from a nested object structure
 */
export const extractUUIDs = obj => {
    const uuids = [];
    function traverse(o) {
        for (const key in o) {
            if (o.hasOwnProperty(key)) {
                if (key === 'uuid' && typeof o[key] === 'string') {
                    uuids.push(o[key]);
                } else if (typeof o[key] === 'object' && o[key] !== null) {
                    traverse(o[key]);
                }
            }
        }
    }
    traverse(obj);
    return uuids;
};

/**
 * 替換文本中的變量
 * @param {string} text - 要處理的文本
 * @param {Object|string} [data] - 要替換成的數據，可以是字符串或對象。若為對象，則鍵名對應變量名
 * @returns {string} 處理後的文本
 */
export const replaceTextVariable = (text, data) => {
    // 從文本中提取所有變量名
    const extractVariables = txt => {
        const atRegex = /@([a-zA-Z0-9_]+)/g;
        const systemRegex = /{{system:([a-zA-Z0-9_]+)}}/g;

        const atMatches = [...txt.matchAll(atRegex)].map(match => match[1]);
        const systemMatches = [...txt.matchAll(systemRegex)].map(match => match[1]);

        return [...new Set([...atMatches, ...systemMatches])];
    };

    const variables = extractVariables(text);

    if (variables.length === 0) {
        return text;
    }

    let result = text;

    // 如果提供了數據
    if (data !== undefined) {
        // 處理對象類型的數據
        if (typeof data === 'object' && data !== null) {
            // 檢查對象是否為空
            if (Object.keys(data).length === 0) {
                return text; // 如果是空對象，直接返回原文本
            }

            for (const variable of variables) {
                // 只有當對象中存在對應的鍵時才進行替換
                if (data[variable] !== undefined) {
                    const value = data[variable] === null ? '' : data[variable];
                    result = result
                        .replace(new RegExp(`@${variable}`, 'g'), value)
                        .replace(new RegExp(`{{system:${variable}}}`, 'g'), value);
                }
            }
        }
        // 處理字符串類型的數據 (所有變量替換為相同的值)
        else {
            const value = data === null ? '' : data;
            for (const variable of variables) {
                result = result
                    .replace(new RegExp(`@${variable}`, 'g'), value)
                    .replace(new RegExp(`{{system:${variable}}}`, 'g'), value);
            }
        }
        return result;
    }

    // 如果沒有提供數據，則進行格式轉換
    for (const variable of variables) {
        if (result.includes(`@${variable}`)) {
            result = result.replace(new RegExp(`@${variable}`, 'g'), `{{system:${variable}}}`);
        } else if (result.includes(`{{system:${variable}}}`)) {
            result = result.replace(new RegExp(`{{system:${variable}}}`, 'g'), `@${variable}`);
        }
    }

    return result;
};
